document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    }); 

    var swiperSliderAccordion = document.querySelectorAll('.slider-accordion');
    if(swiperSliderAccordion){
        swiperSliderAccordion.forEach((item)=>{
            var swiperAcc = new Swiper('.slider-accordion__slide', {
                /*Optional parameters*/
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                allowTouchMove: false
            });
            
            (function(){
                let allAccordionItems = document.getElementsByClassName('js-accordion-title');
                let allAccordions = document.querySelectorAll('#slider-accordion .item');
                let allALength = allAccordionItems.length;					
        
                for(let i = 0 ; i < allALength; i++){
                    allAccordionItems[i].addEventListener('click', function(){
                        let currentParent = this.parentElement;
                        
                        let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
                        let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0];
                        if(currentParent.classList.contains('open')){
                            currentParent.classList.remove('open');
                            currentCopy.style.height = '0';
                        } else {
                            allAccordions.forEach(item => {
                                item.classList.remove('open');
                                item.getElementsByClassName('js-accordion-copy')[0].style.height = '0';
                            });
                            setTimeout(() => {
                                currentParent.classList.add('open');
                                currentCopy.style.height = currentCopyHeight + 'px';
                            }, "100");
                        }
                        swiperAcc.slideTo(i);							
                    })
                    allAccordionItems[0].click();
                }
        
            }())
        });
    };
    var swiperReviews = document.querySelectorAll('.reviews');
    if(swiperReviews){
        swiperReviews.forEach((item)=>{
            var swiperReview = new Swiper('.reviews__swiper', {
                /*Optional parameters*/
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                allowTouchMove: true,
                pagination: {
                    el: ".reviews__pagination",
                    clickable: true,
                }	
            });
        });
    };
    var swiperAmenities = document.querySelectorAll('.amenities-slider');
    if(swiperAmenities){
        swiperAmenities.forEach((item)=>{
            var swiperAmenities = new Swiper('.amenities-sliderSwiper', {
                /*Optional parameters*/
                slidesPerView: 2,
                allowTouchMove: true,
                pagination: {
                    el: ".amenities-slider__pagination",
                    clickable: true,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 4,
                        spaceBetween: 45
                    }
                  }
            });
        });
    };
    
    var swiperGallery = document.querySelectorAll('.gallery-block');
    if(swiperGallery){
        swiperGallery.forEach((item)=>{
            var swiperGallery = new Swiper('.gallery-block__swiper', {
                /*Optional parameters*/
                allowTouchMove: true,
                slidesPerView: 1.2,
                centeredSlides: true,
                spaceBetween: 15,
                pagination: {
                    el: ".gallery-block__pagination",
                    clickable: true,
                }	
            });
        });
    };

    let introContentImage = new Swiper('.swiper.intro-content__image', {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });

    let sliderInAccordion = new Swiper('.slider-accordion__images-slide', {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-accordion-button-next",
            prevEl: ".swiper-accordion-button-prev",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });
});